/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonaResDto } from '../../models/persona-res-dto';
import { UpdatePersonaDto } from '../../models/update-persona-dto';

export interface PersoneControllerUpdatePersona$Params {
  idPersona: number;
  body: UpdatePersonaDto;
}

export function personeControllerUpdatePersona(
  http: HttpClient,
  rootUrl: string,
  params: PersoneControllerUpdatePersona$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PersonaResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    personeControllerUpdatePersona.PATH,
    'patch',
  );
  if (params) {
    rb.path('idPersona', params.idPersona, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonaResDto>;
      }),
    );
}

personeControllerUpdatePersona.PATH = '/admin/persona/id/{idPersona}';
